// --------------------------------------------------------------------------
// Rendered when multiple results returned
// --------------------------------------------------------------------------

import React from 'react';
import lookup from './words.js';
import styles from './index.module.css';

// --------------------------------------------------------------------------

class MultipleResults extends React.Component {

    // ----------------------------------------------------------------------

    render() {
        
        let wines = this.props.wines;
        
        return (
            <div className={styles.bsMultipleResultsPage}>
                <div className={styles.bsHeader}>
                    <h1>{lookup('headingMultipleResults')}</h1>
                    <p>{lookup('textMultipleResults')}</p>
                </div>
                <div className={styles.bsCenter}>
                    <div className={styles.bsResultsList}>
                        {wines.map((wine) =>
                                
                            <button onClick={ (e) => { this.onSelectWine(wine); } }>{wine.name} {wine.vintage}</button>
                            
                        )}
                    </div>
                </div>
                <div className={styles.bsFooter}>
                    <button className={styles.bsInternalNavButton} onClick={ (e) => { this.props.onTryAgain(); } }>{lookup('buttonTryAgain')}</button>
                </div>
            </div>
        )
    }

    onSelectWine(wine) { this.props.onSelectWine(wine); }

}

// --------------------------------------------------------------------------

export default MultipleResults;

// --------------------------------------------------------------------------
